import { useTheme } from "app/shared";
import { FC } from "react";
import styles from "./TokenUtility.module.scss";

interface ITokenUtility {
  tokenUtilityData: { label: string; value: string }[];
  className?: string;
}

const TokenUtility: FC<ITokenUtility> = ({ tokenUtilityData, className }) => {
  const { theme } = useTheme();

  return (
    <>
      <div className={styles.header}>
        <h2 className={styles.title}>Token Utility</h2>
      </div>
      <div
        className={`${styles.wrapper} ${className || ""} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        <ul className={styles.list}>
          {tokenUtilityData.map((utility, index) => (
            <li key={index} className={styles.item}>
              <div className={styles.utilityCard}>
                <span className={styles.label}>{utility.label}</span>
                <p className={styles.value}>{utility.value}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default TokenUtility;
